var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
const SvgIconCheckCircle = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 20 20"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#4F63FF",
  fillRule: "nonzero",
  d: "M14 0c7.732 0 14 6.268 14 14s-6.268 14-14 14S0 21.732 0 14 6.268 0 14 0m0 1.5C7.096 1.5 1.5 7.096 1.5 14S7.096 26.5 14 26.5 26.5 20.904 26.5 14 20.904 1.5 14 1.5M8.166 13.373a.8.8 0 1 0-1.132 1.132l4.804 4.804a.8.8 0 0 0 1.132 0l8.364-8.365a.8.8 0 0 0-1.131-1.131l-7.8 7.799z"
})));
export default SvgIconCheckCircle;